import Pill from 'ext-ui/components/Pill/Pill'
import Markdown from 'markdown-to-jsx'
import React from 'react'
import { useTranslate } from 'src/localization/Trns'

import styles from './TaskRenderer.style'

interface TaskRendererProps {
  title: string
  description: string
  subagentType?: string
  content?: string // Content to display (for results)
  isLoading?: boolean // Show loading shimmer
}

/**
 * Renders a task/subagent execution with description and type
 */
const TaskRenderer: React.FC<TaskRendererProps> = ({
  title,
  description,
  subagentType,
  content,
  isLoading = false,
}) => {
  const translate = useTranslate()

  return (
    <div css={styles} className="TaskRenderer">
      <div className="header">
        <div className={`title ${isLoading ? 'loading' : ''}`}>
          {translate(title)}
        </div>
        {subagentType && (
          <Pill size="small" color={isLoading ? 'saas' : 'highlight'}>
            {subagentType.replace(/_/g, ' ')}
          </Pill>
        )}
      </div>
      <div className="description">{description}</div>
      {content && (
        <div className="result-content">
          <Markdown options={{ forceInline: true }}>{content}</Markdown>
        </div>
      )}
    </div>
  )
}

export default TaskRenderer
